import { createStore } from 'vuex';
import modalManagementSystem from './modules/modal-management-system';
import recaptcha from './modules/recaptcha';

export default createStore({
    modules: {
        modalManagementSystem,
        recaptcha
    },
})